import React from "react";
import Button from "../../components/button";
import PopUp, { openPopUp } from "../../components/popUp";
import TextField from "../../components/textField/textField";
import { useAppContext } from "../../context/appContext";

export default function UpdateEmailPopUp() {

    const {settingsController, sessionId} = useAppContext();

    const [error, setError]= React.useState<string | undefined>(undefined);
    const [email, setEmail] = React.useState("");

    async function updateEmail() {
        try {
            const data = (await settingsController.changeEmail(sessionId, {
                    email: email
                })).data;
            window.location.href = "/signup/verifyEmail/"+data.accountId;
        } catch(error: any) {
            setError(error.response.data.message);
        }
    }

    return <PopUp title="Change Email">
        <TextField label="New Email" type="email" value={email} onChange={setEmail}/>
        <p className="error">{error}</p>
        <Button onClick={updateEmail}>Update Email</Button>
    </PopUp>

}